import ReviewsPeriodInsight from '@app/model/review/digest/ReviewsPeriodInsight';
import ReviewsStateForPeriod from '@app/model/review/state/ReviewsStateForPeriod';

export class ReviewsMonthlyDigest {
	current: ReviewsStateForPeriod | null;
	previous: ReviewsStateForPeriod | null;
	insights: ReviewsPeriodInsight[];

	constructor(data: ReviewsMonthlyDigest) {
		this.current = data.current ? new ReviewsStateForPeriod(data.current) : null;
		this.previous = data.previous ? new ReviewsStateForPeriod(data.previous) : null;
		this.insights = data.insights ?? [];
	}
}
